import { render, staticRenderFns } from "./resourceHeaderTemplate.vue?vue&type=template&id=2258720e&scoped=true&"
import script from "./resourceHeaderTemplate.vue?vue&type=script&lang=js&"
export * from "./resourceHeaderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258720e",
  null
  
)

export default component.exports